export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4648.e468213b.jpg";